import styled from "styled-components";
import SearchIcon from "../../../../../images/common/search-charcoal-grey.svg";
import { AuthService, CustomLabel, RedButton } from "@mindmemobile/mm-shared-global";
import { theme } from "@mindmemobile/mm-shared-global";
import { NavpillContainer } from "./NavPills.styles"; 

interface IStyleProps {
  height?: string;
  width?: string;
  bgColor?: string;
  customCollapsibleWidth?: string;
  isCollapsed?: boolean;
  margin?: string;
  marginLeft?: string;
  border?: any;
  padding?: any;
}
export const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  > div:not(.layout-footer) {
    width: 100%;
  }
  .layout-footer {
    width: calc(100% - 480px);
  }
  @media (max-width: 1700px) {
    .layout-footer {
      > div {
        margin-bottom: 20px;
      }
      button {
        min-width: 115px !important;
      }
    }
  }
`;
export const MainContent = styled.div`
  /* height: calc(100vh - 50px); */
  display: flex;
  width: 100%;
  height: 100%;
  /* Some common classes */
  .dollar-usd-input {
    .input-wrapper {
      position: relative;
      &::after {
        content: "USD";
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        font-size: 16px;
        color: #aaa;
      }
      &::before {
        content: "$";
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        font-size: 18px;
        color: #555;
      }
    }
    input[type="text"] {
      width: 220px;
      padding-left: 30px;
      padding-right: 45px;
    }
    &.usd-with-error {
      .input-wrapper {
        &::after {
          top: 19px;
        }
        &::before {
          top: 19px;
        }
      }
      &.usd-impact-right {
        .input-wrapper {
          max-width: 250px;
          &::after {
            right: 38px;
          }
        }
        .error-message {
          line-height: 16px;
        }
      }
    }
  }
  .dollar-input {
    .input-wrapper {
      position: relative;
      &::before {
        content: "$";
        position: absolute;
        top: 50%;
        left: 12px;
        transform: translateY(-50%);
        font-size: 18px;
        color: #555;
      }
    }
    input[type="text"] {
      width: 120px;
      padding-left: 30px;
      padding-right: 15px;
    }
  }
  .percent-left-input {
    .input-wrapper {
      position: relative;
      &::after {
        content: "%";
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        font-size: 18px;
        color: #555;
      }
    }
    input[type="text"] {
      width: 120px;
      padding-right: 30px;
      padding-left: 0px;
    }
  }
  .usd-input {
    .input-wrapper {
      position: relative;
      &::after {
        content: "USD";
        position: absolute;
        top: 50%;
        right: 12px;
        transform: translateY(-50%);
        font-size: 16px;
        color: #aaa;
      }
    }
    input[type="text"] {
      padding-right: 45px;
    }
  }
  .percent-input {
    .input-wrapper {
      position: relative;
      &::after {
        content: "%";
        position: absolute;
        top: 7px;
        right: 12px;
        /* transform: translateY(-50%); */
        font-size: 16px;
        color: #555;
        font-weight: 400;
      }
    }
    input[type="text"] {
      padding-left: 10px;
      padding-right: 35px;
    }
  }
  .action-button {
    color: #555;
    height: 50px;
    border-radius: 10px;
    border: 1px solid #aaa;
    background: #f8f8f8;
    padding: 14px;
    & > img {
      width: 26px;
      height: 26px;
      margin-right: 8px;
    }

    &.active {
      border: 1px solid #57ac2d;
      background: #f7fff3;
    }
  }
  .standard-lh {
    line-height: normal;
  }
  .padding-left-40 {
    padding-left: 40px !important;
  }
  .search-input-wrapper {
    .input-wrapper {
      position: relative;
      &::before {
        background: url(${SearchIcon});
        height: 20px;
        width: 20px;
        content: "";
        top: 50%;
        background-size: 20px;
        left: 8px;
        transform: translateY(-50%);
        font-size: 18px;
        color: #555;
        position: absolute;
      }
    }
    input {
      padding-left: 35px !important;
    }
  }
  .no-scroll {
    overflow: hidden !important;
  }
  .small-input {
    width: 50px;
    height: 36px;
    text-align: center;
  }
  .red-strike {
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    color: #f00;
    margin-right: 12px;
    vertical-align: top;
    text-decoration: line-through;
  }
  .discounted-price {
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
  &.product-pricing-page {
    .collapsed-header-label {
      font-weight: 600;
      font-size: 22px;
    }
    i {
      &.fa-chevron-down {
      }
      &.fa-chevron-right {
        margin-top: 5px !important;
      }
    }
  }
  .price-increase-interval {
    width: 220px !important;
    .header {
      width: 220px !important;
    }
    .error-message {
      line-height: 16px;
    }
  }
  .price-increase-amount {
    width: 150px !important;
    .header {
      width: 150px !important;
    }
  }
  .price-interval-input {
    gap: 2px !important;
    .dropdown-input .header {
      padding-left: 0px !important;
    }
    .dropdown-option {
      span {
        color: #555;
      }
    }
  }
`;

export const CustomLine = styled.div<IStyleProps>`
  height: ${(props) => props.height || "2px"};
  width: ${(props) => props.width || "2px"};
  background-color: ${(props) => props.bgColor || "#aaa"};
  margin: ${(props) => props.margin || "0px"};
`;
export const DashboardGrid = styled.div`
  padding: 0px 0px 0px 30px;
  height: ${(props) =>
    AuthService.fromPaymentSystem ? "calc(100vh - 118px)" : "100vh"};
  background-color: #f4f7fb;
  .db-search-input {
    height: 40px;
    img {
      height: 18px !important;
      width: 18px !important;
    }
    input {
      border: none;
      height: 40px;
      background-color: transparent;
      width: 220px;
      font-size: 16px;
      &::placeholder {
        font-size: 16px;
      }
      &:focus {
        outline: none;
      }
    }
  }
  .merchant-account-plh {
    padding: 30px 30px 30px 0px;
    height: 100%;
    > div {
      height: 100%;
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0.3em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid rgba(21, 40, 55, 0.3);
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
      > div {
        flex: 1;
        padding: 30px 0px;
        height: 100%;
        button {
          margin-bottom: 30px;
        }
      }
    }
  }
  .db-header-sidebar {
    min-width: 300px; // so that donation donor button UI doesn't break
    ${CustomLabel} {
      font-size: 24px;
      color: #2c3e50;
      line-height: 30px;
    }
    ${CustomLine} {
      height: 24px;
      width: 1px;
    }
    .db-header-flex {
      height: 40px;
    }
  }
  .db-header-title {
    max-width: 500px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .db-header-icons img {
    height: 25px;
    width: 25px;
  }
  .add-new-dpdn {
    /* max-height: 300px; */
    max-height: calc(100vh - 220px);
    /* height: 150px; */
    width: 200px;
    display: block;
    position: absolute;
    right: 0;
    overflow-y: visible;
    /* overflow-y: auto; // Creating issue for tooltip */
    top: 0;
    transform: translate(1px, 55px);
    border: 1px solid #556bb8;
    background-color: #fff;
    font-size: 15px;
    img {
      height: 20px;
      width: 20px;
      margin-right: 15px;
      margin-bottom: 5px;
    }
    a:active {
      background-color: transparent;
      color: #212529;
    }
    a:focus {
      outline: none;
    }
    &.dropdown-menu {
      &::before {
        position: absolute;
        top: 0px;
        left: unset;
        right: 0px;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #556bb8;
        border-left: 10px solid transparent;
        content: "";
        transform: translate(-21px, -10px);
      }
      &::after {
        position: absolute;
        top: 0px;
        left: unset;
        right: 0px;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        border-left: 10px solid transparent;
        content: "";
        transform: translate(-21px, -8.5px);
      }
    }
    div {
      overflow-y: auto;
      /* height: 280px; */
      max-height: calc(100vh - 250px);
      height: 100%;

      &::-webkit-scrollbar {
        width: 0.3em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid rgba(21, 40, 55, 0.3);
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
    }
  }
  .border-bottom-blue {
    border-bottom: 2px solid ${theme.palette.info.dark} !important;
    border-radius: 0px !important;
  }
  .processor-row {
    .merchant-description-cell {
      height: 40px;
      width: 100%;
      img {
        height: 100%;
        width: auto;
        max-width: 100%;
      }
    }
    .merchant-label-cell {
      label {
        line-height: 40px;
      }
    }
  }
  /* &.contact-routes-only {
    .plh-main-section {
      border: none;
    }
  } */
`;
export const DashboardArea = styled.div<IStyleProps>`
  display: flex;
  gap: 20px;
  height: ${(props) =>
    props.height ||
    (AuthService.fromPaymentSystem
      ? "100%"
      : "calc(100vh - 128px)")}; // apply {height: calc(100vh - 200px)}, when there is a notification box
  /* transition:
        height 0.3s ease-in-out,
        padding 0.3s ease-in-out;  */
  .collapsed-styles {
    .sidebar-header {
      padding: 20px;
      /* transition: padding 0.3s ease-in-out; */
      label {
        display: none;
      }
    }
    .sidebar-body {
      padding: 0px !important;
      /* transition: padding 0.3s ease-in-out; */
      div {
        padding: 10px 14px;
      }
      label {
        display: none;
      }
    }
  }
  &.content-area-only {
    padding: 35px 0px 30px;
    // height: 100%;
    flex: 1 1 0;
    /* transition:
            height 0.3s ease-in-out,
            padding 0.3s ease-in-out;  */
  }
`;
export const DashboardSidebar = styled.div<IStyleProps>`
  border-radius: 10px;
  width: ${(props) =>
    props.isCollapsed
      ? "60px"
      : props.customCollapsibleWidth
        ? props.customCollapsibleWidth
        : "300px"};
  /* height: calc(100vh - 267px); */
  border: 1px solid #ddd;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  transition: all 0.3s;
  scrollbar-gutter: stable both-edges;
  .collapsed-center {
    justify-content: center;
    img {
      margin-right: 0px !important;
    }
  }
`;
export const GridFrame = styled.div`
  border-radius: 10px;
  flex: 1 1 0;
  padding-right: 25px;
  overflow-y: auto;
  transition: all 0.3s;
  /* padding-bottom: 30px; */
  /* overflow-x: hidden; */
  /* width: 1800px; */
  overflow-x: auto;
  height: 100%;

  /* scrollbar-gutter: stable both-edges; */
  /* max-width: calc(100vw - 380px); */ // creating issue while collapsed
  /* border: 1px solid #ddd; */
  &::-webkit-scrollbar {
    width: 0.5em;
    height: 0.6em;
    background-color: #15283717;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }
`;
export const SidebarHeader = styled.div`
  background-color: #f8f8f8;
  /* height: 70px; */
  height: 57px; // to match the height of right side
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  border-radius: 10px 10px 0px 0px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ddd;
  ${CustomLabel} {
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
  }
  i {
    font-size: 18px;
    transition: all 0.3s;
  }
`;
export const SidebarBody = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 0px 15px 10px;
  flex: 1 1 0;
  img {
    font-size: 20px;
  }
  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.6em;
    background: transparent;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ededed;
    background-color: #15283715;
    border-radius: 10px;
  }
`;
export const SidebarLabels = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  ${CustomLabel} {
    color: #2c3e50;
    line-height: 26px;
    font-weight: 600;
  }
  img {
    height: 20px;
    width: 20px;
    margin-right: 20px;
    margin-bottom: 1px;
  }
  &:not(.disabled):hover {
    background-color: #f8f8f8;
    cursor: pointer;
    border-radius: 8px;
    ${CustomLabel} {
      color: #2c3e50;
      cursor: pointer;
      font-weight: 600;
      line-height: 26px;
    }
  }
  &.active:not(.disabled) {
    background-color: rgba(85, 107, 184, 0.1);
    cursor: pointer;
    border-radius: 8px;
    ${CustomLabel} {
      color: #556bb8;
      cursor: pointer;
      font-weight: 600;
      line-height: 26px;
    }
  }
`;

export const Topbar = styled.div`
  background-color: #152837;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  padding: 10px;
  div {
    width: 350px;
    text-align: right;
  }
`;

export const LabelCell = styled.div<IStyleProps>`
  width: ${(props) => props.width || "230px"};
  flex-shrink: 0; // creating issue if the description is long it reduce its width
  > label {
    &:not(.prc-multi-label, .standard-lh) {
      line-height: 40px;
    }
    &.prc-multi-label {
      margin-top: 5px;
      width: 150px;
      line-height: 22px;
    }
    &.standard-lh {
      line-height: normal;
    }
  }
  &.reduced-width {
    width: 200px;
  }
`;
export const MainOuterCard = styled.div<IStyleProps>`
  background-color: #fff;
  padding: ${(props) => props.padding || "30px 25px"};
  border: ${(props) => props.border || "1px solid #ddd"};
  border-radius: 10px;
  margin: ${(props) => props.margin || "0px"};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "auto"};
  .label-description-row {
    margin: 0px 0px 20px;
  }
  ${LabelCell} {
    width: 200px;
  }
  ${NavpillContainer} {
    /* padding-right: 66px; */
  }
  .attribute-edit-panel {
    ${LabelCell} {
      width: 100px;
    }
  }
  &.db-min-height {
    min-height: 500px;
  }
  p {
    margin-bottom: 0px;
  }
  &.main-card-min-width {
    min-width: 500px;
  }
  .referral-add-icon {
    margin: 0px 10px 4px 0px;
    height: 20px;
    width: 20px;
    cursor: pointer;
  }
  .payment-settings-header {
    label {
      font-size: 22px;
      font-weight: 600;
    }
  }
  .carousel-default-space {
    min-height: 200px;
    height: 250px;
  }
  .preview-left-panel {
    width: 45%;
  }
  .preview-detail-section {
    width: 55%;
  }
  .multiple-items-description {
    max-height: 4.5rem;
    overflow-y: auto;
    height: auto;
    color: #555;
    height: 4.5rem;
    &::-webkit-scrollbar {
      width: 0.3em;
      height: 0.4em;
      background-color: #15283717;
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid rgba(21, 40, 55, 0.3);
      background-color: rgba(21, 40, 55, 0.3);
      border-radius: 10px;
    }
  }
  &.no-media-item {
    min-height: 350px !important;
    .carousel-default-space {
      min-height: 0px;
      height: 0px;
    }
  }
  /* &.item-unavailable {
    min-height: 628px !important;
    &.no-media-item {
      min-height: 380px;
      .carousel-default-space {
        min-height: 0px;
        height: 0px;
      }
    }
  } */
  .item-unavailable-warning {
    height: 22px;
  }
  &.custom-option-item-card {
    height: 642px;
  }

  @media (min-width: 200px) and (max-width: 1500px) {
    .carousel-default-space {
      min-height: auto;
    }
  }
  @media (max-width: 1069px) {
    .carousel-default-space {
      min-height: auto;
      height: auto;
    }
    .multiple-items-description {
      height: auto;
      &.multiple-items-description-no-content{
        display: none;
      }
    }
    .display-none-ss {
      display: none;
    }
    &.custom-option-item-card {
      height: auto;
    }
  }
  @media (min-width: 1800px) {
    .preview-left-panel {
      width: 40%;
    }
    .preview-detail-section {
      width: 60%;
    }
  }
`;
export const ItemImage = styled.div<IStyleProps>`
  height: 100px;
  width: 100px;
  border-radius: 6px;
  background-color: ${(props) => props.bgColor || "#f4f4f4"};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
  .plus-hovered {
    display: none;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
  }
  .overlay-product {
    background-color: #273e52bf;
    cursor: pointer;
    position: absolute;
    height: 100%;
    width: 100%;
    display: none;
    border-radius: 6px;
  }
  &:hover {
    .overlay-product {
      display: block;
    }
    cursor: pointer;
    .plus-hovered {
      display: block;
    }
  }
  video,
  .product-image {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    width: 100%;
    min-height: 100px;
    object-fit: scale-down;
  }
  &.uploaded-image {
    height: auto;
    max-width: 150px;
    width: auto;
    border-radius: 10px;
    min-height: 100px;
    max-height: 200px;
    min-width: 100px;
    .product-image {
      height: auto;
      max-width: 150px;
      width: auto;
      border-radius: 10px;
      min-height: 100px;
      max-height: 200px;
      min-width: 100px;
      object-fit: scale-down;
    }
    /* Mobile Pages / Email Templates: show only the top portion at fixed height */
    .product-image--page-preview {
      width: 100px;
      height: 100px;
      min-height: 100px;
      max-height: 100px;
      max-width: 100px;
      min-width: 100px;
      object-fit: cover;
      object-position: top center;
      border-radius: 10px;
    }
    /* Constrain the container when it holds a page-preview image */
    &:has(.product-image--page-preview) {
      height: 100px;
      max-height: 100px;
      width: 100px;
      max-width: 100px;
      min-width: 100px;
      min-height: 100px;
    }
    &.multiple-media-variant {
      background-color: transparent;
      justify-content: flex-start;
      &:first-child {
        width: 100%;
        max-width: unset;
        /* display: block; */ // creating issue for overlaying delete button
        img {
          height: 100%;
          width: auto;
          max-width: 300px;
        }
      }
      &:not(:first-child) {
        height: 60px;
        min-width: 60px;
        max-width: 100px;
        img {
          height: auto;
          width: auto;
          max-width: 200px;
          min-width: 40px;
          max-height: 60px;
          object-fit: contain;
          height: 60px;
          min-width: 60px;
          max-width: 100px;
        }
      }
      .delete-hovered-icon {
        height: 20px !important;
        width: 20px !important;
      }
    }
    /* Read-only variant view: shrink-wrap the first image container so
       border-radius clips to the actual image, not the full-width box.
       First image takes full row width so smaller images wrap to next row.
       Scoped to .variant-readonly-frame — does not affect the edit view. */
    .variant-readonly-frame &.multiple-media-variant {
      &:first-child {
        width: 100%;
        flex-basis: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        background-color: transparent;
        img {
          display: block;
          height: auto;
          width: auto;
          max-width: 270px;
          max-height: 200px;
          border-radius: 10px;
          object-fit: contain;
        }
      }
    }
  }
  .favourite-star {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;
  }
`;

export const ItemFrame = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  /* width: 100px; */
  ${CustomLabel} {
    text-align: center;
    line-height: normal;
    /* text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap; */
    word-break: break-word;
    max-width: 100px;
  }
`;

export const ProductOptionWrapper = styled.div<IStyleProps>`
  width: ${(props) => props.width || "100%"};
  margin-left: ${(props) => props.marginLeft || "0px"};
  .padding-left-40-buttons {
    margin-top: 25px;
    margin-bottom: 20px;
    button {
      height: 40px;
    }
  }
  .label-desc-row-60 {
    margin: 0px 0px 60px;
  }
  .donation-option-buttons {
    border-radius: 4px;
    color: #555555;
    font-size: 16px;
    font-weight: 400;
    /* margin: 10px 0px; */
    width: 85%;
    &.border-grey {
      border: 1px solid #ccc;
    }
    .padding-left-40 {
      padding-left: 20px !important;
      background-color: #fff;
    }
    .padding-left-40-buttons {
      margin: 0px !important;
      background-color: #f8f8f8;
      padding: 20px;
      border-radius: 4px;
      &.curved-border {
        border-radius: 4px 4px 0px 0px;
      }
    }
    /* .overlay-product {
            display: none;
        } */
    ${ItemImage} {
      background-color: transparent;
    }
    ${RedButton}:not(.clear-btn) {
      display: none;
    }
  }
  .row.padding-left-40-row {
    margin: 0px 0px 50px;
  }
  .option-sub-row {
    margin: 30px 0px 40px !important;
  }
  .media-reset-btn {
    margin-top: 32px;
  }
  .option-account-input {
    width: 220px;
    height: 40px;
  }
  .option-category-select {
    min-width: 360px;
    min-height: 40px;
    max-width: 360px;
  }
  .donation-pricing-select {
    min-width: 419px;
    min-height: 40px;
    max-width: 419px;
  }
  .option-select__control {
    min-height: 40px;
  }
  .donation-collapsed {
    margin-bottom: 30px;
    img {
      height: 25px;
      width: 34px;
      margin-right: 10px;
    }
    &.usage-section img {
      width: 34px;
    }
    label {
      font-size: 20px;
    }
    .fa-chevron-down,
    .fa-chevron-right {
      margin-left: 10px;
    }
    .fa-chevron-right {
      margin-top: 4px;
    }
    & + div.show .donation-string-selector {
      margin-right: 5px;
      .options-custom-dropdown {
        width: auto;
        min-width: 30px;
        /* max-width: 100px; */
        .header {
          border: none;
          width: auto;
          max-width: 100px;
          padding-right: 0px;
          color: #556bb8;
          font-weight: 600;
          height: 36px;
          cursor: pointer;
          padding-left: 0px;
          margin-top: 2px;

          .select-header-icon {
            border-left: 0px;
            /* height: 32px; */
            margin-bottom: 3px;
          }
        }
        .options-menu {
          border: none;
          transform: translate(4px, 34px);
          min-width: 100px;
          li {
            cursor: pointer;
          }
        }
      }
    }
    & + div.show .donation-number-select .options-custom-dropdown {
      width: auto;
      min-width: 50px;
      max-width: 100px;
      cursor: pointer;
      margin-right: 7px;
      .header {
        border: none;
        width: auto;
        max-width: 100px;
        padding-right: 0px;
        color: #556bb8;
        font-weight: 600;
        /* height: 36px; */
        .select-header-icon {
          border-left: 0px;
          /* height: 32px; */
          width: 25px;
          margin-top: 1px;
        }
      }
      .options-menu {
        border: none;
        transform: translate(4px, 34px);
        li {
          cursor: pointer;
        }
      }
      .select-header-span {
        margin-right: 15px;
      }
    }
  }
  .donation-options-input {
    width: 150px;
  }
  .range-starts {
    width: 80px;
  }
  .collapsed-card {
    margin-left: 50px;
  }
  .any-all-included-dpdn {
    height: 40px;
    /* margin-top: 1px; */
  }
  .related-item-single-select {
    width: auto !important;
    .header {
      width: auto !important;
    }
  }
  .layout-outer-width {
    width: 60%;
    flex-wrap: wrap;
    min-width: 390px;
  }
  .country-origin-dpdn {
    .country-dropdown {
      width: 300px;
      > div {
        height: 40px;
        border: 1px solid #aaa;
        width: 300px;
        .custom-label {
          font-size: 16px;
        }
        .dropdown {
          width: 100%;
        }
        .dropdown-toggle::after {
          transform: translate(0px, 10px);
        }
        .dropdown-menu {
          transform: translate(-6px, 39px) !important;
          width: 300px;
          .dropdown-item {
            padding-left: 15px;
            color: #555;
          }
        }
      }
    }
  }

  .weight-dropdown {
    min-width: 80px;
    width: auto;
    max-width: 120px;
    .header {
      min-width: 80px;
      width: auto;
      max-width: 120px;
    }
  }
  .weight-input {
    width: 125px;
  }
  .detail-page-soldby-dpdn {
    .single-select-wrapper.dpdn-with-icons,
    .header {
      max-width: 415px;
      width: 415px;
    }
  }
  .related-items-section {
    > div {
      margin: 0px 0px 20px;
    }
  }
  @media (max-width: 1350px) {
    .layout-outer-width {
      width: 80%;
      flex-wrap: wrap;
      min-width: 200px;
      /* .single-checkout-card {
                width: 150px;
            } */
    }
  }
`;
